import { SettingsService } from '../settings.service';
import { Component, Input, OnChanges, SimpleChanges ,OnInit} from '@angular/core';

@Component({
    selector: 'app-activity-hours',
    templateUrl: './activity-hours.component.html',
    styleUrls: ['./activity-hours.component.scss'],
    standalone: false
})
export class ActivityHoursComponent implements OnInit {
  @Input() selectedUserId: number | null = null;
  activityHours = {
    sunday: [],
    monday: [],
    tuesday:[],
    wednesday:[],
    thursday:[],
    friday:[],
    saturday:[],
  };
  saved=false
  constructor(public settings:SettingsService) { }

  ngOnInit(): void {
   
  }
  
  ngOnChanges(changes: SimpleChanges) {
    if (changes.selectedUserId) {
      this.fetchActivityHours();
    }
  }


  
  fetchActivityHours(): void {
    this.settings.getActivityHours().subscribe({
      next: (data) => this.activityHours = data,
      error: (err) => console.error('Failed to fetch activity hours', err)
    });
  }

  saveActivityHours(): void {
    this.settings.saveActivityHours(this.activityHours).subscribe({
      next: (response) => {
        this.saved=true
      this.fetchActivityHours()},
      error: (err) => console.error('Failed to save activity hours', err)
    });
  }

   getUserTimeZone() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  addHour(day: string): void {
    if (!this.activityHours[day]) {
      this.activityHours[day] = [];
    }
    const userTimeZone = this.getUserTimeZone(); // Method that returns a string like "Europe/London"
    this.activityHours[day].push({ startTime: '', endTime: '', status: 'new', dayOfTheWeek: day, timeZone: userTimeZone });
  }
  deleteHour(day, index){
    if (this.activityHours[day] && this.activityHours[day][index]) {
      if (this.activityHours[day][index].AutoIndex) {
        this.activityHours[day][index].status = 'delete';
      }
      else {
        this.activityHours[day].splice(index, 1);
      }
    }
    
  }
  

  markAsUpdated(day: string, index: number): void {
    if (this.activityHours[day] && this.activityHours[day][index] && this.activityHours[day][index].status != 'new') {
      this.activityHours[day][index].status = 'update';
    }
  }

}
